import React from "react";
import PropTypes from "prop-types";

export default function RestaurantImage(props) {
  // const [isOpen, setIsOpen] = React.useState(false);
  const restaurant = props.restaurant;
  const haveImage = !!(
    restaurant.viewStyleSelected &&
    restaurant.viewStyleSelected.enable &&
    restaurant.viewStyleSelected.url
  );

  let alt = "";
  if (
    restaurant &&
    restaurant.viewStyleSelected &&
    restaurant.viewStyleSelected.enable
  ) {
    restaurant.categories.forEach(element => {
      alt += element ? element[`label_it`] : "";
      alt += " ";
    });
    alt += restaurant.name;
    alt += " ";
    if (restaurant[`addressIT`] && restaurant[`addressIT`].city) {
      alt += restaurant[`addressIT`].city;
    }
  }
  let url = "";
  if (
    restaurant.viewStyleSelected &&
    restaurant.viewStyleSelected.enable &&
    restaurant.viewStyleSelected.url
  ) {
    if (
      restaurant.viewStyleSelected.random &&
      restaurant.facebook &&
      restaurant.facebook.cover &&
      restaurant.facebook.cover.source
    ) {
      url = restaurant.facebook.cover.source;
    } else if (
      restaurant.viewStyleSelected.random &&
      restaurant.photo &&
      restaurant.photo.length > 0
    ) {
      url = restaurant.photo[restaurant.photo.length - 1].image_url;
    } else if (restaurant.viewStyleSelected.originalUrl) {
      url = restaurant.viewStyleSelected.originalUrl;
    } else {
      url = restaurant.viewStyleSelected.url;
    }
  }

  return (
    <div>
      <div style={{ width: "100%", position: "relative" }}>
        {haveImage && url ? (
          <div
            className="coverContainer"
            style={{
              backgroundImage: `url('${url}')`,
              position: "relative"
            }}
          >
            {/* <div className="restaurant-cover-layer">
              <h1 className="restaurant-title">{restaurant.name}</h1>
            </div> */}
            {/* <picture>
              <source srcSet={url} type="image/webp" />
              <source srcSet={url} type="image/jpeg" />
              <img alt={alt} src={url} />
            </picture> */}
            {/* {(restaurant.photo && restaurant.photo.length > 0) ||
            (restaurant.restaurantImage &&
              restaurant.restaurantImage.length > 0) ? (
              <RestaurantImages restaurant={restaurant} />
            ) : null} */}
          </div>
        ) : null}
      </div>
    </div>
  );
}

RestaurantImage.propTypes = {
  restaurant: PropTypes.object.isRequired
};
